import React from "react";
import FeedbackComponent from "./FeedbackComponent";

const FeedbackContainer = () => {
  return <FeedbackComponent />;
};

export default FeedbackContainer;
